<wl-content-section [theme]="theme()">
  <wl-simple-table
    [headingField]="title()!"
    [introductionField]="introduction()!"
    [button]="callToAction()!"
    [tableField]="table()!"
  />
</wl-content-section>
